<template>
  <div class="login-score"> 
    <div class="record_msg" v-for="(item,index) in score_list" :key="index">
      <div class="msg">
        <p>
          {{item.content}}
        </p>
        <p>  
          <!-- {{item.userid}}  -->
          <span>
            {{item.create_time}}
          </span>  
        </p>
      </div>
      <div class="moneyNum">
        +{{item.score}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      score_list : []
    }
  },
  created() {
    let uid = JSON.parse(localStorage.getItem("uid"));

    // 积分记录
    this.$axios.post(this.domain.url+"/api/score/index/scorelog",{
      uid : uid,
      type : 1
    }).then((res) => {
      // console.log(res.data.data)
      this.score_list = res.data.data
    })
  },
}
</script>

<style lang="less" scoped>
    // 充值 积分 信息
  .record_msg{
    width: 6.9rem;
    height: 1.3rem;
    background: #ffffff;
    border-radius: .35rem;
    margin: 0 auto;
    margin-bottom: .1rem;
    .msg{
      float: left;
      margin-left: .4rem;
      p{
        &:first-child{
          font-size: 0.28rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #0F0F0F;
          line-height: .28rem;
          margin-top: .34rem;
        }
        &:last-child{
          margin-top: .13rem;
          font-size: 0.28rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #0F0F0F;
          line-height: .28rem;
        }
      }
    }
    .moneyNum{
      float: right;
      margin-right: .29rem;
      line-height: 1.3rem;
      font-size: 0.34rem;
      font-family: PingFang SC;
      font-weight: bold;
      color: #FF9645;
    }
  }
</style>